import React from "react";
import ReactDOM from "react-dom";
import LogRocket from "logrocket";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";

// Logging
if (process.env.NODE_ENV === "production") {
  LogRocket.init("sbgcc9/catchtrips");
}

// Redux
import { Provider } from "react-redux";
import store from "./store";

// Components
import App from "./App";
import ErrorBoundary from "./ErrorBoundary";
import LandingPage from "./scenes/LandingPage";
import SearchResultsPage from "./scenes/SearchResultsPage";
import ReservationsPage from "./scenes/ReservationsPage";
import TripSearchPage from "./scenes/TripSearchPage";
import ReviewOrderPage from "./scenes/ReviewOrder";
import OrderConfirmationPage from "./scenes/OrderConfirmation";
import LocationSuggestionsPage from "./scenes/LocationSuggestionsPage";
import ScrollToTop from "./ScrollToTop";
ReactDOM.render(
  <Provider store={store}>
    <ErrorBoundary>
      <Router>
        <ScrollToTop>
          <App>
            <Switch>
              <Route exact path="/" component={LandingPage} />
              <Route path="/search-results" component={SearchResultsPage} />
              <Route
                path="/location-suggestions"
                component={LocationSuggestionsPage}
              />
              <Route path="/review-order" component={ReviewOrderPage} />
              <Route
                path="/order-confirmation"
                component={OrderConfirmationPage}
              />
              <Route path="/find-my-trip" component={TripSearchPage} />
              <Route path="/reservations" component={ReservationsPage} />
              {/* Redirect to home page if page doesn't exist. Can use 404 */}
              <Redirect to="/" />
            </Switch>
          </App>
        </ScrollToTop>
      </Router>
    </ErrorBoundary>
  </Provider>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js